/* eslint-disable */
export const snackUtil = {
  snack: (text, type) => {
    if (!type) {
      type = 'info';
    }
    document.dispatchEvent(new CustomEvent('snack', {
      detail: {
        text: text,
        type: type,
      },
    }));
  },
};
